import { render, staticRenderFns } from "./PlayoffTree.vue?vue&type=template&id=598fccd6&"
import script from "./PlayoffTree.vue?vue&type=script&lang=js&"
export * from "./PlayoffTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports